import { render } from "./anquanjianchadan.vue?vue&type=template&id=10b21ee9&scoped=true&ts=true"
import script from "./anquanjianchadan.vue?vue&type=script&lang=ts"
export * from "./anquanjianchadan.vue?vue&type=script&lang=ts"

import "./anquanjianchadan.vue?vue&type=style&index=0&id=10b21ee9&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b21ee9"]])

export default __exports__